import { useEffect, useState } from 'react';
import CISection from './CISection';
import MainSwiperSection from './MainSwiperSection';
import Section01 from './Section01';
import Section02 from './Section02';
import Section03 from './Section03';
import Section04 from './Section04';
import Section05 from './Section05';
import MainCarsayoGiftPopup from './MainCarsayoGiftPopup';

interface MainContentProps {
  sectionRefs: {
    section1: React.RefObject<HTMLDivElement>;
    section2: React.RefObject<HTMLDivElement>;
    section3: React.RefObject<HTMLDivElement>;
    sectionCI: React.RefObject<HTMLDivElement>;
    section4: React.RefObject<HTMLDivElement>;
  };
  scrollToSection: (section: string) => void;
}

const MainPage = ({ sectionRefs, scrollToSection }: MainContentProps) => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const popupLocalStorage = localStorage.getItem('popupTodayHidden');

    if (!popupLocalStorage) {
      setIsPopupOpen(true);
      return;
    }

    if (Date.now() > Number(popupLocalStorage)) {
      localStorage.removeItem('popupTodayHidden');
      setIsPopupOpen(true);
    } else {
      setIsPopupOpen(false);
    }
  }, []);
  return (
    <div>
      {/* <MainSwiperSection scrollToSection={scrollToSection} /> */}
      {/* <Section01 scrollToSection={scrollToSection} /> */}
      <section className='w-full'>
        <div className='w-full pt-[80px] max-w-[1080px] px-[1%] mx-auto'>
          <p className='text-[#222] text-[24px] leading-[38.4px] font-[600] mb-[40px]'>
            The Federation of
            <br />
            Korean Sales and Business
          </p>
          <ul className='w-full flex flex-col justify-start items-start gap-[12px]'>
            <li className='overflow-hidden w-full rounded-[10px]'>
              <img
                src='/imgs/section0_bg01.webp'
                alt='배경이미지1'
                className='w-full min-h-[380px] object-cover'
              />
            </li>
            <li className='overflow-hidden w-full rounded-[10px]'>
              <img
                src='/imgs/section0_bg02.webp'
                alt='배경이미지2'
                className='w-full min-h-[380px] object-cover'
              />
            </li>
          </ul>
        </div>
      </section>
      <Section02 contentsRef={sectionRefs.section1} />
      <Section03 contentsRef={sectionRefs.section2} />
      <Section04 contentsRef={sectionRefs.section3} />
      <CISection contentsRef={sectionRefs.sectionCI} />
      <Section05 contentsRef={sectionRefs.section4} />
      {/* <MainCarsayoGiftPopup mode='canCloseOneDay' /> */}
    </div>
  );
};
export default MainPage;
